const aspectRatios = {
    "1:1": "1 / 1",
    "3:2": "3 / 2",
    "4:5": "4 / 5",
    "4:3": "4 / 3",
    "5:7": "5 / 7",
    "6:7": "6 / 7",
    "7:5": "7 / 5",
    "8:3": "8 / 3",
    "12:5": "12 / 5",
    "13:9": "13 / 9",
    "15:7": "15 / 7",
    "16:9": "16 / 9",
};

export default aspectRatios;
